import React from 'react';
import AboutNav from '../Components/Navigation/AboutNav';
import Footer from '../Components/Home/Footer';
import SEBISlider from '../Components/Common/SEBISlider';
import ISOCertificateButton from '../Components/Common/ISOCertificateButton';
import '../Assets/Styles/Pages/payment_page.css';
import bankLogo from '../Assets/Images/Bank-of-Baroda-Logo.png';

const Payment_page = () => {
  const bankDetails = {
    accountName: "Trillion Stock Research",
    accountNumber: "41910200000519",
    bankName: "BANK OF BARODA",
    ifscCode: "BARB0PALDAX",
    branch: "Palda Indore, Madhya Pradesh, 452012",
    upiId: "updating soon"
  };

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
    // You can add a toast notification here if needed
  };

  return (
    <div className="payment-page-unique">
      <AboutNav />
      <SEBISlider />
      
      <section className="payment-hero-unique">
        <div className="payment-hero-content-unique">
          <h1>Bank Details</h1>
          <p>Make your payment using our secure bank details</p>
        </div>
      </section>

      {/* Bank Details Summary Section */}
      <section className="bank-summary-section-unique">
        <div className="container">
          <div className="bank-summary-card-unique">
            <div className="bank-logo-container-unique">
              <img src={bankLogo} alt="Bank of Baroda" className="bank-logo-unique" />
            </div>
            <div className="bank-summary-content-unique">
              <h2>Payment Summary</h2>
              <div className="summary-grid-unique">
                <div className="summary-item-unique">
                  <span className="summary-label-unique">Bank:</span>
                  <span className="summary-value-unique">{bankDetails.bankName}</span>
                </div>
                <div className="summary-item-unique">
                  <span className="summary-label-unique">Account:</span>
                  <span className="summary-value-unique">{bankDetails.accountName}</span>
                </div>
                <div className="summary-item-unique">
                  <span className="summary-label-unique">Account No:</span>
                  <span className="summary-value-unique">{bankDetails.accountNumber}</span>
                </div>
                <div className="summary-item-unique">
                  <span className="summary-label-unique">IFSC:</span>
                  <span className="summary-value-unique">{bankDetails.ifscCode}</span>
                </div>
                <div className="summary-item-unique">
                  <span className="summary-label-unique">Branch:</span>
                  <span className="summary-value-unique">{bankDetails.branch}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="payment-container-unique">
        <div className="payment-intro-unique">
          <h2>Complete Bank Details</h2>
          <p>Please use the following bank details to make your payment. After making the payment, please contact us with the transaction details.</p>
        </div>

        <div className="bank-details-container-unique">
          <div className="bank-details-card-unique">
            <div className="bank-header-unique">
              <div className="bank-logo-small-unique">
                <img src={bankLogo} alt="Bank of Baroda" />
              </div>
              <h3>Bank Account Details (Bank of Baroda - Current Account)</h3>
            </div>
            
            <div className="bank-info-unique">
              <div className="info-row-unique">
                <span className="label-unique">Account Name</span>
                <div className="value-container-unique">
                  <span className="value-unique">{bankDetails.accountName}</span>
                  <button onClick={() => copyToClipboard(bankDetails.accountName)} className="copy-btn-unique">
                    Copy
                  </button>
                </div>
              </div>

              <div className="info-row-unique">
                <span className="label-unique">Account Number</span>
                <div className="value-container-unique">
                  <span className="value-unique">{bankDetails.accountNumber}</span>
                  <button onClick={() => copyToClipboard(bankDetails.accountNumber)} className="copy-btn-unique">
                    Copy
                  </button>
                </div>
              </div>

              <div className="info-row-unique">
                <span className="label-unique">Bank Name</span>
                <div className="value-container-unique">
                  <span className="value-unique">{bankDetails.bankName}</span>
                  <button onClick={() => copyToClipboard(bankDetails.bankName)} className="copy-btn-unique">
                    Copy
                  </button>
                </div>
              </div>

              <div className="info-row-unique">
                <span className="label-unique">IFSC Code</span>
                <div className="value-container-unique">
                  <span className="value-unique">{bankDetails.ifscCode}</span>
                  <button onClick={() => copyToClipboard(bankDetails.ifscCode)} className="copy-btn-unique">
                    Copy
                  </button>
                </div>
              </div>

              <div className="info-row-unique">
                <span className="label-unique">Branch</span>
                <div className="value-container-unique">
                  <span className="value-unique">{bankDetails.branch}</span>
                  <button onClick={() => copyToClipboard(bankDetails.branch)} className="copy-btn-unique">
                    Copy
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="upi-details-card-unique">
            <div className="bank-header-unique">
              <div className="bank-icon-unique">💳</div>
              <h3>UPI Payment Details</h3>
            </div>
            
            <div className="bank-info-unique">
              <div className="info-row-unique">
                <span className="label-unique">UPI ID</span>
                <div className="value-container-unique">
                  <span className="value-unique">{bankDetails.upiId}</span>
                  <button onClick={() => copyToClipboard(bankDetails.upiId)} className="copy-btn-unique">
                    Copy
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="payment-instructions-unique">
          <h2>Payment Instructions</h2>
          <div className="instructions-list-unique">
            <div className="instruction-item-unique">
              <div className="instruction-icon-unique">✓</div>
              <p>Transfer the exact amount to the provided bank account</p>
            </div>
            <div className="instruction-item-unique">
              <div className="instruction-icon-unique">✓</div>
              <p>Keep the payment receipt for future reference</p>
            </div>
            <div className="instruction-item-unique">
              <div className="instruction-icon-unique">✓</div>
              <p>Contact us with transaction details after payment</p>
            </div>
            <div className="instruction-item-unique">
              <div className="instruction-icon-unique">✓</div>
              <p>Payment confirmation will be sent via email</p>
            </div>
          </div>
        </div>

        <div className="security-features-unique">
          <h2>Secure Payment Process</h2>
          <div className="security-grid-unique">
            <div className="security-card-unique">
              <div className="security-icon-unique">🔒</div>
              <h3>Bank-Grade Security</h3>
              <p>Your payment is processed through secure banking channels</p>
            </div>
            <div className="security-card-unique">
              <div className="security-icon-unique">🛡️</div>
              <h3>Verified Account</h3>
              <p>All transactions are processed through our verified bank account</p>
            </div>
            <div className="security-card-unique">
              <div className="security-icon-unique">✓</div>
              <h3>Instant Confirmation</h3>
              <p>Receive immediate confirmation of your payment</p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
      <ISOCertificateButton />
    </div>
  );
};

export default Payment_page;
